import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

export const useStyles = makeStyles(theme => ({
  colorText: {
    color: theme.palette.common.second1,
    fontSize: 18,
    lineHeight: 'normal',
    fontWeight: 'normal',
    marginLeft: 18,
  },
  inputBase: {
    height: 'auto',
  },
  error: {
    fontSize: '15px',
  },
}))

export const Title = styled.div`
  display:flex;
  margin-bottom: 10px;
  align-items: center;
`

export const Item = styled.div`
  grid-column: -2 / -1;
  display: flex;
  flex-direction: column;
`
